import { forwardRef, type InputHTMLAttributes } from "react";

import { cn } from "@/src/lib/utils";

export interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  error?: boolean;
}

export const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ className, error, ...props }, ref) => (
    <input
      ref={ref}
      className={cn(
        "w-full rounded-sm border border-neutral-300 bg-neutral-50 px-3 py-2.5 text-sm text-neutral-700 transition-colors placeholder:text-neutral-400 focus:border-brand focus:ring-1 focus:ring-brand focus:outline-none disabled:cursor-not-allowed disabled:bg-neutral-100 disabled:text-neutral-500",
        error && "border-error focus:border-error focus:ring-error",
        className,
      )}
      {...props}
    />
  ),
);

Input.displayName = "Input";
